import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class PayrollDeductionBus extends BaseBus {
    constructor(busObj: PayrollDeductionBus = null) {
        super(busObj);
        if (busObj !== undefined && busObj !== null) {
            this.payWeekStartDate = DateFunctions.getDate(busObj.payWeekStartDate);
        }
    }
    setId(id: any) {
        this.payMiscDeductTypeId = id;
    }
    setParentId(id: any) {
        // this.timeOffRequestId = id;
    }
    CID(): any {
        return this.payMiscDeductTypeId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {

    }
    setFromForm(data: PayrollDeductionBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

    }
    payMiscDeductTypeId: any;
    amount: number;
    miscDeductTypeId: any;
    note: string;
    personId: any;
    payWeekStartDate: Date;
    companyId: any;
    parentId: string;
    parentType: string;
    weeksAcross: number;
    resourceName: string;
    payMiscDeductType: string;
    empNo: string;
}
